import { createContext, useContext } from 'react'

const CardRemoveContext = createContext(null)

export function CardRemoveProvider({ onRemove, children }) {
  return <CardRemoveContext.Provider value={onRemove}>{children}</CardRemoveContext.Provider>
}

export function useCardRemove() {
  return useContext(CardRemoveContext)
}
